<template>
  <div class="container-fluid px-0">
    <div id="advanced_search_policy" class="collapse">
      <hr class="line">
        <div class="row mx-0">
          <div class="col-lg-3 col-md-4 col-sm-6 col-12">
            <div class="row form-group">
              <float-label label="PIN Status" :fixed='isFloat(data.pinStatus.value)'>
                <select class="form-control" id="exampleFormControlSelect1" v-model="data.pinStatus.value" @change="checkDate()">
                  <option disabled :value='null'>PIN Status</option>
                  <option v-for="(pinStatus,index) in data.pinStatus.options" :key="index" :value="pinStatus.code"> {{pinStatus.name}} </option>
                </select>
              </float-label>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-12" v-if="!verify_roles(['EXTERNAL_AGENCY'])">
            <div class="row form-group">
              <float-label :fixed='isFloat(data.endorsementPolicyNo.value)'>
                <input
                  type="text"
                  class="form-control"
                  :class="{'bgc-error-field':data.endorsementPolicyNo.errorText != ''}"
                  v-on:keydown="alphaNumeric"
                  v-model="data.endorsementPolicyNo.value"
                  maxlength="30"
                  id="policyNumber"
                  placeholder="Endorsement/Policy Number"
                >
              </float-label>
              <span class="error-text">{{data.endorsementPolicyNo.errorText}}</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-12">
            <div class="row form-group my-0 mx-auto">
              <RegNumSearch :registrationData="data.vehicleRegistrationNo" @setvehicledetails="setVehicleDetails" fromSource="PIN"></RegNumSearch>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-12" v-if="!verify_roles(['EXTERNAL_AGENCY'])">
            <div class="row form-group">
              <float-label :fixed='isFloat(data.clientFirstName.value)'>
                <input
                  @change="checkDate()"
                  type="text"
                  class="form-control"
                  :class="{'bgc-error-field':data.clientFirstName.errorText != ''}"
                  v-on:keydown="onlyCharSpace"
                  v-model="data.clientFirstName.value"
                  maxlength="10"
                  id="clientName"
                  placeholder="Client First Name"
                >
              </float-label>
              <span class="error-text">{{data.clientFirstName.errorText}}</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-12">
            <div class="row form-group">
              <float-label :fixed='isFloat(data.pinRegistrationFromDate.value)'>
                <datepicker format="dd/MM/yyyy" id="reg_from"
                  :input-class="isInputError(data.pinRegistrationFromDate.errorText)" :disabledDates="DisableFromDate" :typeable="true"
                  @datePickerBlurred="checkError(data.pinRegistrationFromDate,false)" @closed="removeErrorIfNotBlank(data.pinRegistrationFromDate);checkDate()"
                  placeholder="PIN Registration From" v-model="data.pinRegistrationFromDate.value" @cleared="checkDate()">
                </datepicker>
              </float-label> 
              <span class="error-text">{{data.pinRegistrationFromDate.errorText}}</span> 
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-12">
            <div class="row form-group">
              <float-label :fixed='isFloat(data.pinRegistrationToDate.value)'>
                <datepicker format="dd/MM/yyyy" id="reg_to"
                  :input-class="isInputError(data.pinRegistrationToDate.errorText)" :disabledDates="DisableToDate" :typeable="true"
                  @datePickerBlurred="checkError(data.pinRegistrationToDate,false)" @closed="removeErrorIfNotBlank(data.pinRegistrationToDate);checkDate()"
                  placeholder="PIN Registration To" v-model="data.pinRegistrationToDate.value" @cleared="checkDate()">
                </datepicker>
              </float-label> 
              <span class="error-text">{{data.pinRegistrationToDate.errorText}}</span> 
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-12">
            <div class="row form-group">
              <float-label :label="(data.vehicleRegistrationNo.values[0] == 'NE' && data.vehicleRegistrationNo.values[1] == 'W')?'Engine Number*':'Engine Number'" :fixed='isFloat(data.engineNumber.value)'>
            <input
              type="text"
              :placeholder="(data.vehicleRegistrationNo.values[0] == 'NE' && data.vehicleRegistrationNo.values[1] == 'W')?'Engine Number*':'Engine Number'"
              class="form-control capital-input"
              maxlength="30"
              :class="{'bgc-error-field':data.engineNumber.errorText !== '' && data.vehicleRegistrationNo.values[0] == 'NE' && data.vehicleRegistrationNo.values[1] == 'W'}"
              v-evolvews= "data.engineNumber"
              v-model="data.engineNumber.value"
              v-on:keyup="makeChaEngUpperCase($event, 'ENGINE')"
            />
          </float-label>
          <span
            class="error-text"
            v-if="data.engineNumber.errorText!=='' && data.vehicleRegistrationNo.values[0] == 'NE' && data.vehicleRegistrationNo.values[1] == 'W'"
            >{{data.engineNumber.errorText}}</span> 
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-12">
            <div class="row form-group">
             <float-label :label="(data.vehicleRegistrationNo.values[0] == 'NE' && data.vehicleRegistrationNo.values[1] == 'W')?'Chassis Number*':'Chassis Number'" :fixed='isFloat(data.chassisNumber.value)'>
            <input
              type="text"
              :placeholder="(data.vehicleRegistrationNo.values[0] == 'NE' && data.vehicleRegistrationNo.values[1] == 'W')?'Chassis Number*':'Chassis Number'"
              class="form-control capital-input"
              maxlength="30"
              :class="{'bgc-error-field':data.chassisNumber.errorText !== '' && data.vehicleRegistrationNo.values[0] == 'NE' && data.vehicleRegistrationNo.values[1] == 'W'}"
              v-evolvews= "data.chassisNumber"
              v-model="data.chassisNumber.value"
              v-on:keyup="makeChaEngUpperCase($event, 'CHASSIS')"            
            />
          </float-label>
          <span
            class="error-text"
            v-if="data.chassisNumber.errorText!=='' && data.vehicleRegistrationNo.values[0] == 'NE' && data.vehicleRegistrationNo.values[1] == 'W'"
            >{{data.chassisNumber.errorText}}</span> 
            </div>
          </div>
        </div>
        <hr class="line mt-5">
        <div class="row mt-4 mb-4">
          <div class="col butn pr-2"> 
            <button
            type="button"
            class="bgc-btn-primary float-right search_button mr-2 mt-2"
            @click="searchPin"
            :disabled="disableAdvanceSearch"
            >Search</button>
            <button
            type="button"
            class="bgc-btn-secondary float-right reset_button mt-2"
            @click="reset"
            >Reset</button>
            <button
            type="button"
            class="bgc-btn-secondary float-right back_button mt-2" @click="goBack" >Back</button>
          </div>
        </div>
      <hr class="line">
    </div>
  </div>
</template>

<script>
import datepicker from "vuejs-datepicker";
import FloatLabel from "@/../../shared_component/FloatLabel.vue";
import functions from '@/../../masters/functions.js';
import { computed } from '@vue/composition-api';
import RegNumSearch from '@/../../shared_motor_component/RegNumSearch.vue'
import { data } from "jquery";


export default {
  name: "AdvanceSearch",
  props: ['data'],
  components: {
    datepicker,
    FloatLabel,
    RegNumSearch
  },
  setup(props, context){
    const isFloat = functions.isFloat;
    const referenceID= functions.referenceID;
    const isInputError= functions.isInputError;
    const onlyNumber= functions.onlyNumber;
    const onlyCharSpace= functions.onlyCharSpace;
    const alphaNumeric= functions.alphaNumeric;
    const checkError= functions.checkError;
    const removeErrorIfNotBlank= functions.removeErrorIfNotBlank;
    const DisableFromDate = computed(()=> {
        let endDate = props.data.pinRegistrationToDate.value;
        if(endDate) {
            let curDate = new Date('"' + endDate.getFullYear() + "," + (endDate.getMonth() + 1) + "," + endDate.getDate() +
                    '"');
            return {
                from: new Date(curDate.valueOf()+ 1000*3600*24*1),
                to: new Date(curDate.valueOf()- 1000*3600*24*30+ 1000*3600*24*1)
            }
        }
    })
    const DisableToDate = computed(()=>{
        let startDate = props.data.pinRegistrationFromDate.value;
        if(startDate) {
            let curDate = new Date('"' + startDate.getFullYear() + "," + (startDate.getMonth() + 1) + "," + startDate.getDate() +
                    '"'); 
            return {
                to: new Date(curDate.valueOf()),
                from: new Date(curDate.valueOf()+ 1000*3600*24*30)
            }
        }
    })
    const disableAdvanceSearch = computed(()=>{
        if(props.data.endorsementPolicyNo.value || props.data.vehicleRegistrationNo.value !== 'NEW'){
            return false
        }
        else if((props.data.clientFirstName.value || props.data.pinStatus.value)&& props.data.pinRegistrationFromDate.value && props.data.pinRegistrationToDate.value){
            return false
        }
        else if(props.data.vehicleRegistrationNo.value == 'NEW' && props.data.engineNumber.value && props.data.chassisNumber.value){
          return false;
        }
        return true
    })
    function setVehicleDetails(e){
      if(props.data.vehicleRegistrationNo.errorText ==''){
          if(props.data.vehicleRegistrationNo.values.filter((val, index)=> index!==2).every(val=> val!=='') && props.data.vehicleRegistrationNo.value!=='NEW'){
              props.data.vehicleRegistrationNo.value=props.data.vehicleRegistrationNo.values[2] ? props.data.vehicleRegistrationNo.values.join('-') : props.data.vehicleRegistrationNo.values[0]+
              '-'+props.data.vehicleRegistrationNo.values[1]+'-'+props.data.vehicleRegistrationNo.values[3];
          }else if(props.data.vehicleRegistrationNo.value=='NEW' && props.data.vehicleRegistrationNo.values[0]=='' &&
              props.data.vehicleRegistrationNo.values[1]==''){
              props.data.vehicleRegistrationNo.value = '';
          }
          else if(props.data.vehicleRegistrationNo.value=='NEW'){
            context.root.$set(props.data.chassisNumber,'skip', undefined);
            context.root.$set(props.data.engineNumber,'skip', undefined);
            context.root.$set(props.data.chassisNumber,'required', true);
            context.root.$set(props.data.engineNumber,'required', true);
          }
      } 
    }
    function verify_roles(requiredRoles) {
      if( typeof(context.root.$store.state.security.auth.realmAccess) !== 'undefined' )
      {
        let agentRoles = context.root.$store.state.security.auth.realmAccess.roles;
        for( let i=0; i< requiredRoles.length;i++ )
        {
          for( let j=0;j<agentRoles.length;j++ )
          {
            if( agentRoles[j] == requiredRoles[i] )
            {
              return true;
            }
          }
        }
        return false;
      }
      else{
        return false;
      }
    }
    function checkDate(){
      if(props.data.clientFirstName.value || props.data.pinStatus.value){
        props.data.pinRegistrationFromDate.skip= undefined;
        props.data.pinRegistrationToDate.skip=undefined;
        checkError(props.data.pinRegistrationFromDate,false)
        checkError(props.data.pinRegistrationToDate,false);
      }
      else{
        props.data.pinRegistrationFromDate.skip= true;
        props.data.pinRegistrationToDate.skip=true;
        props.data.pinRegistrationFromDate.errorText = '';
        props.data.pinRegistrationToDate.errorText = '';  
      }
    }
    function searchPin(){
        context.emit('searchPin');
    }
    function reset(){
        props.data.pinStatus.value = null;
        props.data.endorsementPolicyNo.value = null;
        props.data.vehicleRegistrationNo.value = null;
        props.data.pinRegistrationFromDate.value = null;
        props.data.clientFirstName.value = null;
        props.data.pinRegistrationToDate.value = null;
        props.data.pinRegistrationFromDate.errorText = '';
        props.data.pinRegistrationToDate.errorText = '';
        props.data.engineNumber.value = null;
        props.data.chassisNumber.value = null;
        context.parent.resetSearchPinResp();
    }

    function goBack() {
        context.root.$router.push({ name: "GeneratePin" });
    }

    function makeChaEngUpperCase(evt, source){
      if(source == 'CHASSIS')
        props.data.chassisNumber.value = evt.target.value.toUpperCase();
      if(source == 'ENGINE')
        props.data.engineNumber.value = evt.target.value.toUpperCase();
    }
    return {
      DisableFromDate,
      DisableToDate,
      disableAdvanceSearch,
      checkDate,
      searchPin,
      reset,
      isFloat,
      referenceID,
      onlyCharSpace,
      isInputError,
      onlyNumber,
      alphaNumeric,
      checkError,
      removeErrorIfNotBlank,
      goBack,
      verify_roles,
      setVehicleDetails,
      makeChaEngUpperCase
    };
  },
  directives: {
    evolvews: functions.evolvews
  }
};
</script>

<style>
.vdp-datepicker__calendar {
  width: auto;
}
</style>
<style scoped>
.bgc-btn-secondary {
  margin-right: 18px;
}
@media (max-width: 472px) {
  .bgc-btn-primary {
    width: 93%;
    position: relative;
    right: 11px;
  }
  .bgc-btn-secondary {
    width: 93%;
  }
}
@media (max-width: 420px) {
  .search_button,
  .back_button .reset_button {
    width: 93%;
  }
}
@media (max-width: 382px) {
  .search_button,
  .back_button .reset_button {
    width: 93%;
  }
}
</style>